import { render } from "./ValidateDomain.vue?vue&type=template&id=3e0dc52b&scoped=true"
import script from "./ValidateDomain.vue?vue&type=script&lang=js"
export * from "./ValidateDomain.vue?vue&type=script&lang=js"

import "./ValidateDomain.vue?vue&type=style&index=0&id=3e0dc52b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0dc52b"]])

export default __exports__